import { Check } from 'lucide-react';
import type { OpeningStage } from './replayRequests';

/** The API reports stages, so the bar stays indeterminate until data arrives. */
export default function ReplayLoadingProgress({ stage }: { stage: OpeningStage }) {
  const loadingData = stage === 'data';
  return <div className="replay-loading-progress">
    <div className="replay-loading-stages" role="status">
      <span className={loadingData ? 'is-complete' : 'is-current'} aria-current={!loadingData ? 'step' : undefined}>
        <i aria-hidden="true">{loadingData ? <Check size={12}/> : '1'}</i>赛事信息<small>{loadingData ? '已完成' : '进行中'}</small>
      </span>
      <span className={loadingData ? 'is-current' : ''} aria-current={loadingData ? 'step' : undefined}>
        <i aria-hidden="true">2</i>首段回放<small>{loadingData ? '进行中' : '待开始'}</small>
      </span>
    </div>
    <div className="replay-loading-track" role="progressbar" aria-label="赛事回放加载" aria-valuetext={loadingData ? '正在载入首段回放，赛事信息已完成' : '正在获取赛事信息'}>
      <span/>
    </div>
  </div>;
}
